"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferCaps;
(function (BufferCaps) {
    BufferCaps[BufferCaps["default"] = 1] = "default";
    BufferCaps[BufferCaps["round"] = 1] = "round";
    BufferCaps[BufferCaps["flat"] = 2] = "flat";
    BufferCaps[BufferCaps["square"] = 3] = "square";
})(BufferCaps = exports.BufferCaps || (exports.BufferCaps = {}));
